var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600",
      "line-height": "26px",
      "margin-bottom": "18px"
    }
  }, [_vm._v("咨询分类")]), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "labelCn",
      label: "简体名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "labelEn",
      label: "英文名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "labelTw",
      label: "繁体名称"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "code",
      label: "分类缩写"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "icon",
      label: "浅色图标"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-image", {
          attrs: {
            src: scope.row.icon,
            width: "20"
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "darkIcon",
      label: "深色图标"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-image", {
          attrs: {
            src: scope.row.darkIcon,
            width: "20"
          }
        })];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };